<template>
	<div v-if="ratingsForm.stars && ratingsForm.stars !== ''" class="trustpilot-reviews" :style="{ display: 'none' }">
		<GlobalIcon name="trustpilot-icon" :width="16" />
		<div class="trustpilot-reviews__divider"></div>
		<div class="trustpilot-reviews__container">
			<div class="trustpilot-reviews__stars">
				<GlobalRating :rating="ratingsForm.stars" readonly colorFilled="#00B67A" colorEmpty="#00B67A" />
			</div>
			<p class="trustpilot-reviews__text">
				{{ formatRating(ratingsForm.ratings) }},
				<a :href="ratingsForm.url" target="_blank" class="trustpilot-reviews__link">
					{{ ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
				</a>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
const trustpilotRatingsStore = useTrustpilotRatingsStore()

const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

watch(
	() => trustpilotRatingsStore.getTrustpilotRating,
	(v) => {
		if (v) {
			ratingsForm.stars = v.stars
			ratingsForm.ratings = v.ratings
			ratingsForm.ratingsCount = v.ratingsCount
			ratingsForm.url = v.url
		}
	},
	{ immediate: true },
)
</script>

<style scoped lang="scss" src="./TrustpilotReviews.scss"></style>
